<template>
  <v-app>
    <!-- 
      User Nav Drawer 
    -->
    <v-dialog
        v-model="dialogOpen"
        max-width="500px"
    >
        <v-card>
            <v-card-title>
                <span class="dialogTitle">System Settings</span>
            </v-card-title>
            <v-card-text>
              <v-list>
                <v-subheader class="system_setting_subheader">
                  <span style="flex:3;">
                    Performance Ticker
                  </span>
                  <span style="flex:1;">
                    <v-switch
                      v-model="stock_ticker"
                      style="float:right"
                      dense
                      @change="toggle_system_preference"
                    ></v-switch>
                  </span>
                </v-subheader>
                <v-list-item one-line>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        class="toolbar_selector"
                        label="Stock ticker range"
                        persistent-hint
                        :items="stock_ticker_range"
                        item-text="label"
                        item-value="value"
                        v-model="selectedTickerRange"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item one-line>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        class="toolbar_selector"
                        label="Stock ticker period"
                        persistent-hint
                        :items="stock_ticker_period"
                        item-text="label"
                        item-value="value"
                        v-model="selectedTickerPeriod"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item one-line>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        class="toolbar_selector"
                        v-model="selected_levels"
                        :items="project_levels"
                        label="Levels"
                        multiple
                        hint="Pick the level of granularity you wish to view the data."
                        persistent-hint
                        chips
                        :rules="[selected_levels.length <= 2]"
                        :error-messages="
                          selected_levels.length <= 2
                            ? []
                            : ['Please select no more than 2 data levels']
                        "
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-card-actions>
                <v-row class="ma-0 pa-0">
                  <v-spacer></v-spacer>
                  <v-col cols="auto">
                    <v-btn class="actionText" outlined color="black" @click="dialogOpen = false;">Cancel</v-btn>
                  </v-col>
                  <v-col cols="auto">
                    <v-btn class="actionText" outlined color="black" @click="update_ticker()">Save Changes</v-btn>
                  </v-col>
                </v-row>                
              </v-card-actions>
        </v-card>
    </v-dialog>
    <v-navigation-drawer
      v-if="$auth.isAuthenticated && !$route.meta.hideNavbar"
      v-model="user_drawer"
      class="user-navigation-drawer"
      temporary
      absolute
      app
      color="primary"
      dark
      right
    >
      <template v-slot:prepend>
        <v-list-item one-line>
          <v-list-item-avatar style="background-color: #ffffff50">
            <img :src="$auth.user.picture" :alt="$auth.user.name" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="docma-text-navigation-user">{{
              $auth.user.name
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="ma-0 pa-0 mx-6"></v-divider>
        <v-list-item one-line>
          <v-list-item-avatar
            ><v-icon>mdi-account-group-outline</v-icon></v-list-item-avatar
          >
          <v-list-item-content>
            <v-list-item-title class="docma-text-navigation-user">
              <div class="organization-title">
                <div class="organization-title-content">
                  {{
                    user_orgs && user_orgs[$auth.user.org_id]
                      ? user_orgs[$auth.user.org_id]["display_name"]
                      : $auth.user.org_id
                  }}
                </div>
                <v-tooltip left v-if="Object.keys(user_orgs).length > 1">
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="toolButton" v-on="on" @click="switchOrg">
                      <v-icon dark color="#FFFFFF">mdi-autorenew</v-icon>
                    </v-btn>
                  </template>
                  <span class="tooltip_description" style="display: inline-block">
                    Switch Organization
                  </span>
                </v-tooltip>
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="ma-0 pa-0 mx-6"></v-divider>
        <v-row class="ma-0 pa-0 px-4 py-4" align="center">
          <span class="Brand-name-title">System Preferences</span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn icon class="toolButton" v-on="on" @click="dialogOpen = true;">
                <v-icon color="#FFFFFF">mdi-cog-outline</v-icon>
              </v-btn>
            </template>
            <span class="tooltip_description" style="display: inline-block">
              Edit Eystem Preferences
            </span>
          </v-tooltip>
        </v-row>
      </template>
      <v-divider class="ma-0 pa-0 mx-6"></v-divider>
      <v-row class="ma-0 pa-0">
        <v-row class="ma-0 pa-0 px-4 pt-4" align="center">
          <span class="Brand-name-title">My Brands</span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn icon class="toolButton" v-on="on" @click="get_my_projects">
                <v-icon color="#FFFFFF">mdi-folder-refresh-outline</v-icon>
              </v-btn>
            </template>
            <span class="tooltip_description" style="display: inline-block">
              Refresh My Brands
            </span>
          </v-tooltip>
        </v-row>
        <v-row v-for="(env, idx) in environments" :key="idx" class="ma-0 pa-0">
          <v-col cols="12" class="ma-0 pt-0 px-4">
            <span class="Environment-name-title" v-if="environments.length > 1">{{
              env
            }}</span>
          </v-col>
          <v-col
            cols="12"
            class="ma-0 py-0 px-4"
            v-for="(brand, jdx) in my_brands[env]"
            :key="jdx"
          >
            <v-switch
              class="ma-0 pa-0 Brand-name-title"
              dense
              :label="brand[1]"
              v-model="tool_state"
              :value="brand[0]"
              @click="tool_state = brand[0]"
            ></v-switch>
          </v-col>
        </v-row>
      </v-row>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn class="docma-text-navigation-logout" block @click="logout">
            Logout
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <!-- 
      APP Bar
     -->
    <v-app-bar
      v-if="$auth.isAuthenticated && !$route.meta.hideNavbar"
      app
      color="primary"
      dark
      height="45px"
      extension-height="48px"
      class="ma-0 pa-0"
      elevation="0"
    >
      <v-row class="ma-0 pa-0 px-3" max-height="100%">
        <v-col cols="12" class="ma-0 pa-0">
          <v-row class="docma-toolbar-logo-row ma-0 pa-0">
            <v-col cols="4" class="ma-0 pa-0" style="max-height: 45px">
              <v-img
                :src="require(`${main_logo_inverterd}`)"
                contain
                max-width="150px"
                max-height="30px"
              ></v-img>
            </v-col>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-0 pa-0 docma-text-navigation-bar-btn"
              text
              plain
              dark
              @click="user_drawer = true"
            >
              <span class="docma-text-navigation-bar-text"
                >Welcome {{ $auth.user.given_name }}</span
              >
              <v-icon>mdi-account-outline</v-icon>
            </v-btn>
            <v-divider vertical color="white" class="ma-0 pa-0 mx-3"></v-divider>
            <v-btn
              class="ma-0 pa-0 docma-text-navigation-bar-btn"
              text
              plain
              dark
              disabled
            >
              <span class="docma-text-navigation-bar-text">Help</span>
              <v-icon>mdi-help-circle-outline</v-icon>
            </v-btn>
            <v-divider vertical color="white" class="ma-0 pa-0 mx-3"></v-divider>
            <v-btn
              class="ma-0 pa-0 docma-text-navigation-bar-btn"
              text
              plain
              dark
              disabled
              @click="feedback = true"
            >
              <span class="docma-text-navigation-bar-text">Feedback</span>
              <v-icon>mdi-comment-quote-outline</v-icon>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <template v-slot:extension>
        <v-row class="ma-0 pa-0" style="height: 100%">
          <v-col cols="10" class="ma-0 pa-0 px-3" style="max-height: 48px">
            <v-tabs v-model="mainTab" align-tabs="start" background-color="#1b1b1b">
              <v-tab class="docma-tool-navigation-bar" value="/audience" to="/audience" v-if="audience_access">Talk Trend</v-tab>
              <v-tab class="docma-tool-navigation-bar" value="/sweetspot" to="/sweetspot" v-if="sweetspot_access">SweetSpot</v-tab>
              <v-tab class="docma-tool-navigation-bar" value="/ort" to="/ort" v-if="ort_access">ORTs</v-tab>
              <v-tab class="docma-tool-navigation-bar" value="/performance" to="/performance" v-if="mmm_access">Performance</v-tab>
              <v-tab class="docma-tool-navigation-bar" value="/admin" to="/admin" v-if="admin_access">Admin</v-tab>
            </v-tabs>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-icon>mdi-bell</v-icon>
          </v-col>
        </v-row>
      </template>
    </v-app-bar>
    <!-- 
      Feedback
    -->
    <v-overlay v-model="feedback">
      <FeedbackCard v-on:close="feedback = false"></FeedbackCard>
    </v-overlay>
    <!-- 
      APP Content
     -->
    <v-main
      style="
        height: calc(100vh-93px);
        max-height: calc(100vh-93px);
        overflow-y: hidden;
        overflow-x: hidden;
      "
      v-if="environment_enabled"
    >
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import FeedbackCard from "./views/FeedbackCard.vue";
import api_caller from "./javascript/data_info.js";
import managment_api_caller from './javascript/user_org_management.js';
// import PerformanceBasePage from './components/Performance/PerformanceBasePage.vue';

import Vue from "vue";
const system_settings = Vue.observable({
  selectedTickerRange: 3,
  selectedTickerPeriod: null,
  selected_levels: [],
  tool_state: null,
  stock_ticker: false,
});

Object.defineProperty(Vue.prototype, "$selectedTickerRange", {
  get() {
    return system_settings.selectedTickerRange;
  },
  set(value) {
    system_settings.selectedTickerRange = value;
  },
});

Object.defineProperty(Vue.prototype, "$selectedTickerPeriod", {
  get() {
    return system_settings.selectedTickerRange;
  },
  set(value) {
    system_settings.selectedTickerRange = value;
  },
});

Object.defineProperty(Vue.prototype, "$selected_levels", {
  get() {
    return system_settings.selected_levels;
  },
  set(value) {
    system_settings.selected_levels = value;
  },
});

Object.defineProperty(Vue.prototype, "$tool_state", {
  get() {
    return system_settings.tool_state;
  },
  set(value) {
    system_settings.tool_state = value;
  },
});

Object.defineProperty(Vue.prototype, "$stock_ticker", {
  get() {
    return system_settings.stock_ticker;
  },
  set(value) {
    system_settings.stock_ticker = value;
  },
});

export default {
  name: "App",

  components: {
    FeedbackCard,
  },
  mounted() {
    if (this.$auth.isAuthenticated) {
      this.user_first_name = this.$auth.user.given_name;
      this.user_full_name = this.$auth.user.name;
      if(this.$route.path !== '/welcome'){
          this.$router.push('/welcome'); 
      }
      this.mainTab = '/welcome'
      this.get_my_projects();
      this.stock_ticker = false;
      // this.stock_ticker = true;
      this.toggle_system_preference();
    }
  },
  updated() {
    if (this.$auth.isAuthenticated && !this.brands_pulled) {
      this.get_my_projects();
      this.get_my_orgs();
      this.stock_ticker = false;
      // this.stock_ticker = true;
      this.toggle_system_preference();
    }
  },
  watch: {
    tool_state: {
      handler: function () {
        this.$project.set_val(this.tool_state);
        this.stock_ticker = false;
        // this.stock_ticker = true;
        this.get_tool_access();
        this.toggle_system_preference();
        this.reset_environment();
      },
    },
  },
  data: () => ({
    main_logo_inverterd: "./assets/docma-logo-white-red.svg",

    logged_in: false,
    user_drawer: false,
    feedback: false,
    user_orgs: {},

    user_first_name: "",
    user_full_name: "",

    tool_state: null,

    my_brands: {},
    environments: [],

    rating: 5,
    rating_follow_up: true,

    rating_success: false,
    rating_error: false,

    mainTab: 2,

    environment_enabled: true,

    brands_pulled: false,

    sliderElements: [],
    dialogOpen: false,

    //System Preferences
    stock_ticker: false,
    stock_ticker_range: [
      { label: "Month", value: 1 },
      { label: "Quarter", value: 3 },
      { label: "Half year", value: 6 },
      { label: "Year", value: 12 },
    ],
    project_levels: [],
    selected_levels: [],
    selectedTickerRange: 3,
    selectedTickerPeriod: null,

    mmm_access: false,
    audience_access: false,
    ort_access: false,
    sweetspot_access: false,
    admin_access: false
  }),
  computed: {
    stock_ticker_period: function () {
      let periodOptions = [];
      switch (this.selectedTickerRange) {
        case 1:
          periodOptions.push({ label: "MoM", value: 1 });
          break;
        case 3:
          periodOptions.push({ label: "QoQ", value: 3 });
          break;
        case 6:
          periodOptions.push({ label: "HoH", value: 6 });
          break;
      }
      periodOptions.push({ label: "YoY", value: 12 });
      return periodOptions;
    },
  },
  methods: {
    reset_environment: function () {
      this.environment_enabled = false;
      // this.stock_ticker = false;
      this.stock_ticker = true;
      this.toggle_system_preference();
      this.update_ticker();
      this.get_project_data();
      setTimeout(() => (this.environment_enabled = true), 500);
    },
    toggle_system_preference: function () {
      Vue.set(Vue.prototype, "$stock_ticker", this.stock_ticker);
    },
    get_tool_access: async function () {
      if(this.$route.path !== '/welcome'){
          this.$router.push('/welcome'); 
      }
      this.mainTab = '/welcome'
      this.mmm_access = false;
      this.audience_access = false;
      this.ort_access = false;
      this.sweetspot_access = false;
      this.admin_access = false;
      let token = await this.$auth.getTokenSilently();
      let body = {
        'project_id': this.$project.get_val()
      }
      let project_access = await managment_api_caller.get_project_tab_access(token, body).then((resp) => {
          return resp["data"];
        })
        .catch(() => {
          return false;
        });
      if(project_access != false && project_access != null){
        this.mmm_access = false;
        this.audience_access = false;
        this.ort_access = false;
        this.sweetspot_access = false;

        this.mmm_access = project_access['MMM'];
        this.audience_access = project_access['Audience'];
        this.ort_access = project_access['ORT'];
        this.sweetspot_access = project_access['SweetSpot'];
        if(this.ort_access){
          if(this.$route.path !== '/ort'){
            this.$router.push('/ort'); 
          }
          this.mainTab = '/ort';
        }
        else if(this.mmm_access){
          if(this.$route.path !== '/performance'){
            this.$router.push('/performance');
          }
          this.mainTab = '/performance';
        }
        else if(this.audience_access){
          if(this.$route.path !== '/audience'){
            this.$router.push('/audience');
          }
          this.mainTab = '/audience';
        }
        else if(this.sweetspot_access){
          if(this.$route.path !== '/sweetspot'){
            this.$router.push('/sweetspot');
          }
          this.mainTab = '/sweetspot';
        }
        else{
          if(this.$route.path !== '/welcome'){
              this.$router.push('/welcome'); 
          }
          this.mainTab = '/welcome'
        }
      }
      else{
        if(this.$route.path !== '/welcome'){
            this.$router.push('/welcome'); 
        }
        this.mainTab = '/welcome'
      }
      let admin_available_access = await managment_api_caller.get_user_admin_access(token, {}).then((resp) => {
          return resp["data"];
        })
        .catch(() => {
          return false;
        });
      if(admin_available_access != false){
        this.admin_access = admin_available_access;
      }
      else{
        this.admin_access = false
      }
    },
    get_project_data: async function () {
      if (this.$project.get_val() == null) {
        return;
      }
      let token = await this.$auth.getTokenSilently();
      let project_info = await api_caller
        .get_project_info(token, this.$project.get_val())
        .then((resp) => {
          return resp["data"];
        })
        .catch(() => {
          return "False";
        });
      if (
        !project_info ||
        project_info === "False" ||
        !Array.isArray(project_info["data_levels"]) ||
        project_info["data_levels"].length === 0
      ) {
        this.project_levels = [];
        this.selected_levels = [];
        this.update_ticker();
        return;
      }
      this.project_levels = project_info["data_levels"];
      this.selected_levels = [project_info["data_levels"][0]];
      this.update_ticker();
    },
    update_ticker: function () {
      if (this.selected_levels.length <= 2) {
        Vue.set(Vue.prototype, "$selectedTickerRange", this.selectedTickerRange);
        Vue.set(Vue.prototype, "$selected_levels", this.selected_levels);
      }
      this.dialogOpen = false;
    },
    get_my_projects: async function () {
      let token = await this.$auth.getTokenSilently();
      let projects = await api_caller
        .get_saved_projects(token)
        .then((resp) => {
          return resp["data"];
        })
        .catch((e) => {
          console.error(e);
          return false;
        });
      if (!projects) {
        return;
      }
      this.environments = Object.keys(projects);
      this.my_brands = projects;
      let project_exists = false;
      let existing_project = null;
      for (let env of this.environments) {
        for (let brand of projects[env]) {
          if (brand[0] === this.tool_state) {
            project_exists = true;
            existing_project = brand;
          }
        }
      }
      if (this.environments.length > 0 && project_exists) {
        this.tool_state = existing_project[0];
        Vue.set(Vue.prototype, "$tool_state", this.tool_state);
        this.reset_environment();
      } else if (this.environments.length > 0) {
        this.tool_state = this.my_brands[this.environments[0]][0][0];
        Vue.set(Vue.prototype, "$tool_state", this.tool_state);
      }
      this.brands_pulled = true;
      this.get_tool_access();
    },
    logout: function () {
      this.$auth.logout({
        logoutParams: {
          returnTo: window.location.origin,
        },
      });
    },
    get_my_orgs: async function () {
      let token = await this.$auth.getTokenSilently();
      let userOrgs = await api_caller
        .get_user_orgs(token, this.$auth.user.sub)
        .then((resp) => {
          return resp["data"];
        })
        .catch((e) => {
          console.error(e);
          return false;
        });
      if (userOrgs) {
        this.user_orgs = userOrgs;
      }
    },
    switchOrg: function () {
      this.$auth.loginWithRedirect();
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Poppins:200,400,600,800");
@import url("https://fonts.googleapis.com/css?family=Amiko:400,600,700");
.docma-tool-navigation-bar {
  font-family: "Poppins" !important;
  font-weight: 600 !important;
  font-size: 0.9em !important;
  background-color: #1b1b1b !important;
}
.docma-text-navigation-bar-text {
  font-family: "Amiko" !important;
  font-size: 0.7em;
}
.docma-text-navigation-bar-btn {
  height: 30px !important;
}
.docma-text-navigation-logout {
  font-family: "Poppins" !important;
  font-weight: 400 !important;
  font-size: 1em !important;
}
.docma-text-navigation-user {
  font-family: "Poppins" !important;
  font-weight: 200 !important;
  font-size: 1.1em !important;
}
.Environment-name-title {
  font-family: "Poppins" !important;
  font-weight: 400 !important;
  font-size: 1.2em !important;
  color: white;
}
.Brand-name-title {
  font-family: "Poppins" !important;
  font-weight: 400 !important;
  font-size: 1em !important;
  color: white;
}
.docma-text-rating-main-title {
  font-family: "Poppins" !important;
  font-weight: 600;
  font-size: 1.2em;
}
.docma-text-rating-title {
  font-family: "Poppins" !important;
  font-weight: 600;
  font-size: 0.9em;
}
.docma-text-rating-text {
  font-family: "Poppins" !important;
  font-weight: 200;
  font-size: 1.1em;
}
.loginFormAlerts {
  font-family: "Poppins" !important;
  position: absolute;
  width: 100%;
  z-index: 4;
}

.user-navigation-drawer {
  z-index: 1200 !important;
}

.organization-title {
  font-family: "Poppins" !important;
  font-weight: 400 !important;
  font-size: 0.7em !important;
  color: white;
  display: flex;
  max-width: 200px;
  align: left;

  .organization-title-content {
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: auto;
    margin: auto;
  }
}
.organization-content {
  font-size: 1em !important;
  padding-bottom: 12px;
}

.system_setting_subheader {
  font-family: "Poppins" !important;
  font-weight: 600 !important;
  font-size: 1.2em !important;
  color: black;
  display: flex;
}

.docma-toolbar-logo-row {
  max-width: 100%;
  width: 100%;
}

/deep/ .v-toolbar__content {
  padding: 0px !important;
}
/deep/ .v-toolbar__extension {
  padding: 0px !important;
}

.theme--dark.v-tabs > .v-tabs-bar {
  background-color: #1b1b1b !important;
}
</style>
